[
  {
    "code": "MH-L",
    "name": "Ralik chain"
  },
  {
    "code": "MH-T",
    "name": "Ratak chain"
  }
]